import Constants from '../../utils/Constants';
import { CommonHttpHelper } from '../../utils/HttpHelper';

export const INITIAL_STATE = {
  isLoading: false,
  isLoaded: false,
  data: [],
  dataAsOptionsWithNames: [],
  message: ''
};

const NO_DATA_MESSAGE = 'The data could not be retrieved from the database.';

const getLscs = (state, setState, isCurrent) => {
  if (state.isLoading !== true && state.isLoaded !== true && !state.message) {
    let newState = {
      ...state,
      isLoading: true,
      isLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const urlWithoutParams = `/OrgUnit/Organization/USAS/OrgLevel/LSC/OrgUnit`;
    const urlWithParams = `/OrgUnit/Organization/USAS/OrgLevel/LSC/OrgUnit?isCurrent=true`;
    const url = isCurrent ? urlWithParams : urlWithoutParams;

    CommonHttpHelper(isCurrent ? urlWithParams : url, 'GET')
      .then((data) => {
        if (!data) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          data.unshift({ orgUnitId: Constants.DEFAULT_ID, orgUnitName: '--' });
          newState = {
            ...newState,
            isLoading: false,
            isLoaded: true,
            data: data,
            dataAsOptionsWithNames: data.map((lsc) => { return { id: lsc.orgUnitId, name: lsc.orgUnitName } }),
            message: '',
          };
          setState(newState);
        }

      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isLoading: false,
          isLoaded: false,
          message: message
        });
      });
  }
};

const LscData = { INITIAL_STATE, getLscs };

export default LscData;